import { BatchSkiptraceStore as BaseBatchSkiptraceStore } from 'features/BatchSkiptrace/infra/views/BatchSkiptraceStore/BatchSkiptraceStore'
import { make } from './make'

export const BatchSkiptraceStore = {
  make,
}

export type BatchSkiptraceStore = BaseBatchSkiptraceStore
